import AdvanceGroupDetails from './AdvanceGroupDetails';

export default AdvanceGroupDetails;
